import { render } from "./contact.vue?vue&type=template&id=c729d144&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=c729d144&scoped=true&lang=css"

import exportComponent from "/home/kira/project/web/SPACDYNA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c729d144"]])

export default __exports__